import { NgModule, CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';
import { KeyValuesPipe } from './pipes/key-values';
import { StepFilterPipe } from './pipes/step-filter';
import { PropertyFilterPipe } from './pipes/property-filter';
import { ControlFilterPipe } from './pipes/control-filter';
import { PdfViewerComponent } from './components/pdf-viewer/pdf-viewer.component';
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid';
import { jqxButtonComponent } from 'jqwidgets-ng/jqxbuttons';
import { jqxCheckBoxComponent } from 'jqwidgets-ng/jqxcheckbox';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { CollapseDirective } from './directives/collapse.directive';
import { CollapseComponent } from './components/collapse/collapse.component';
import { MaximizeComponent } from './components/maximize/maximize.component';
import { MaximizeDirective } from './directives/maximize.directive';
import { ModalDirective } from './directives/modal.directive';
import { ModalComponent } from './components/modal/modal.component';
import { DatePipe, CommonModule, DecimalPipe } from '@angular/common';
import { FeatherIconsComponent } from './components/feather-icons/feather-icons.component';
import { BookmarkComponent } from './components/bookmark/bookmark.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { ToggleFullscreenDirective } from "./directives/fullscreen.directive";
import { LoaderComponent } from './components/loader/loader.component';
import { FormsModule } from '@angular/forms';
import { DragulaModule } from 'ng2-dragula';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { ChartsModule } from 'ng2-charts';
import { AutofocusDirective } from './directives/autofocus.directive';
import { PoliciesComponent } from './components/policies/policies.component';
import { ClaimsComponent } from './components/claims/claims.component';
import { OffersComponent } from './components/offers/offers.component';
import { ProcesscontrolComponent } from './processcontrol/processcontrol.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { DraggableDirective } from './directives/draggable.directive';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { ProcessSummaryComponent } from './processsummary/process-summary.component';
import { ButtonComponent } from './components/button/button.component';
import { AccessAreaDirective } from '../auth/access-area.directive';
import { DxDateBoxModule } from 'devextreme-angular';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
    suppressScrollX: false,
    wheelPropagation: false
};

@NgModule({
    imports: [
          TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useFactory: SharedHttpLoaderFactory,
                deps: [HttpClient]
            },
            isolate: false
          }),
        CommonModule,
        RouterModule,
        FormsModule,
        DragulaModule.forRoot(),
        NgbModule,
        CarouselModule,
        ChartsModule,
        NgSelectModule,
        PerfectScrollbarModule,
        DxDateBoxModule
    ],
    providers: [
        DatePipe,
        DecimalPipe,
        { provide: PERFECT_SCROLLBAR_CONFIG, useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG }
    ],
    declarations: [
        LoaderComponent,
        ToggleFullscreenDirective,
        BookmarkComponent,
        BreadcrumbComponent,
        FeatherIconsComponent,
        CollapseDirective,
        KeyValuesPipe,
        StepFilterPipe,
        PropertyFilterPipe,
        ControlFilterPipe,
        PdfViewerComponent,
        jqxGridComponent,
        jqxButtonComponent,
        jqxCheckBoxComponent,
        CollapseComponent,
        MaximizeComponent,
        MaximizeDirective,
        ModalDirective,
        ModalComponent,
        AutofocusDirective,
        PoliciesComponent,
        ClaimsComponent,
        OffersComponent,
        ProcesscontrolComponent,
        DraggableDirective,
        ProcessSummaryComponent,
        ButtonComponent,
        AccessAreaDirective
    ],
    exports: [
        ChartsModule,
        LoaderComponent,
        FeatherIconsComponent,
        TranslateModule,
        KeyValuesPipe,
        StepFilterPipe,
        PropertyFilterPipe,
        ControlFilterPipe,
        PdfViewerComponent,
        jqxGridComponent,
        jqxButtonComponent,
        jqxCheckBoxComponent,
        CollapseDirective,
        CollapseComponent,
        MaximizeComponent,
        MaximizeDirective,
        ModalDirective,
        ModalComponent,
        BreadcrumbComponent,
        AutofocusDirective,
        PoliciesComponent,
        ClaimsComponent,
        OffersComponent,
        ProcesscontrolComponent,
        DraggableDirective,
        ProcessSummaryComponent,
        ButtonComponent,
        AccessAreaDirective,
    ],
    entryComponents: [ModalComponent]

 })
export class SharedModule { }

// required for AOT compilation
export function SharedHttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, "scripts/libs/assets/i18n/");
}
